import { Component, HostListener } from '@angular/core';
import { keysToTranslate } from 'src/app/core/util/keys-to-translate';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  imports: [NgbPopover, TranslatePipe],
})
export class ScrollToTopComponent {
  public isScrolled = document.documentElement.scrollTop !== 0 || document.body.scrollTop !== 0;

  public constructor() {
    keysToTranslate(['ScrollToTop']);
  }

  @HostListener('window:scroll', ['$event'])
  public onScroll(_event: Event): void {
    this.isScrolled = document.documentElement.scrollTop !== 0 || document.body.scrollTop !== 0;
  }

  public scrollToTop(): void {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
